import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

export default function useSite() : string {
  const { site } = useSelector((state: any) => state?.site)

  // SITE: VITA, ASSICURAZIONI, BANCA
  return site || process.env.SITE
}
